var SKIP_LINKS_DATA_TESTIDS = {
  container: "mntl-skip-links-container"
};

export { SKIP_LINKS_DATA_TESTIDS };
